import { expand } from 'uri-template-lite';
import { apiClient } from '../../common/ApiClient';
import { createApiQueryHook } from '../../common/queryClient/createApiQueryHook';
import { User } from '../types';
import { UserUrl } from './UserUrl';
import { UserSchema } from '../schema';

const getUser = ({ id }: { id: number }) =>
  apiClient
    .get<User>(expand(UserUrl.USER, { id }))
    .then((response) => UserSchema.parseFormData(response.data));

export const useUserQuery = createApiQueryHook(['user'], getUser);
